<div #sheetHandle class="sheet-handle-area">
    <div *ngIf="asBottomSheet" class="sheet-grabber"></div>
    <div class="panel-header">
        <ng-container *ngTemplateOutlet="headerTitle"></ng-container>
        <button
            type="button"
            class="panel-header__download"
            [title]="'common.download' | translate"
            [disabled]="isExporting"
            (click)="exportAsImage()"
        >
            <i
                class="fa"
                [class.fa-download]="!isExporting"
                [class.fa-spinner]="isExporting"
                [class.fa-spin]="isExporting"
                aria-hidden="true"
            ></i>
        </button>
    </div>
</div>

<div class="panel-rows">
    <ng-container
        *ngTemplateOutlet="shiftRows; context: { $implicit: false }"
    ></ng-container>
</div>

<!--
    Off-screen copy captured by the PNG export: same header (without the button) and rows,
    but no selection highlight. Exists only while exporting.
-->
<div *ngIf="isExporting" class="export-stage" aria-hidden="true">
    <div #exportContent class="export-content">
        <div class="panel-header">
            <ng-container *ngTemplateOutlet="headerTitle"></ng-container>
        </div>
        <ng-container
            *ngTemplateOutlet="shiftRows; context: { $implicit: true }"
        ></ng-container>
    </div>
</div>

<ng-template #headerTitle>
    <span class="panel-header__dot" [style.background]="color"></span>
    <span class="panel-header__label" [title]="courierLabel">{{ courierLabel }}</span>
</ng-template>

<!--
    Shift groups and stop rows; shared by the panel (forExport = false) and the export copy
    (forExport = true: no highlight, no click).
-->
<ng-template #shiftRows let-forExport>
    <ng-container *ngFor="let shift of panelShifts; trackBy: trackByKey">
        <div class="shift-header">{{ 'delivery-plan-viewer.shift' | translate: shift.labelParams }}</div>

        <div *ngIf="shift.stops.length === 0" class="shift-empty">
            {{ 'delivery-plan-viewer.no-stops' | translate }}
        </div>

        <div
            *ngFor="let panelStop of shift.stops; trackBy: trackByStopId"
            class="stop-row"
            [class.is-selected]="!forExport && panelStop.stop.id === selectedStopId"
            (click)="!forExport && onStopClicked(panelStop.stop)"
        >
            <span class="stop-row__number" [style.background]="panelStop.color">
                {{ panelStop.number }}
            </span>
            <div class="stop-row__text">
                <div class="stop-row__type" [style.color]="panelStop.color">
                    {{ panelStop.typeLabelKey | translate }}
                </div>
                <div>{{ panelStop.stop.orderCode }}</div>
                <div class="stop-row__eta">
                    {{ 'delivery-plan-viewer.eta' | translate: { time: panelStop.eta } }}
                </div>
            </div>
        </div>
    </ng-container>
</ng-template>